import { action, computed, extendObservable, observable, runInAction } from 'mobx';

import { getErrorString, Logger, NOOP_LOGGER } from 'bernie-logger';
import { SerializedData, Store } from 'bernie-core';

import { ShortlistApiSource } from 'sources/shortlist-api-source';

import { STORE_EVENTS } from './events/store-events';

import { HotelViewModel } from 'models';

export class ShortlistStore extends Store {
  constructor(private shortlistSource: ShortlistApiSource, state: SerializedData, logger: Logger = NOOP_LOGGER) {
    super(state, logger);
  }

  public hydrate(data: SerializedData): void {
    if (data.shortlistSource) {
      Object.assign(this.shortlistSource, {
        clientHeaders: data.shortlistSource.clientHeaders || {},
        clientQueryParams: data.shortlistSource.clientQueryParams || {}
      });
    }

    delete data.shortlistSource;
    Object.assign(this, data);
  }

  public static DEFAULTS = {
    isLoading: true,
    shouldFetchFreshData: false,
    hotel: {
      favoritedLocally: {},
      favorited: [],
      recentlyViewed: []
    },
    hotelIdFromMap: undefined
  };

  @observable
  public hotelIdFromMap: number;
  @observable
  public isLoading: boolean;
  @observable
  public shouldFetchFreshData: boolean;
  @observable
  public hotel: {
    favoritedLocally: any;
    favorited: HotelViewModel[];
    recentlyViewed: HotelViewModel[];
  };
  @observable
  public error: any;
  @observable
  public errors: any[];

  @computed
  get isError(): boolean {
    return Boolean(this.error || this.errors);
  }

  @action
  public updateFavoritedLocally(id: any, status: boolean, category: string): void {
    const hotelId = Number(id);
    const updatedValue = {
      [hotelId]: status
    };
    extendObservable(this[category].favoritedLocally, updatedValue);
  }

  @action
  public resetHotelIdFromMap() {
    this.hotelIdFromMap = undefined;
  }

  @action
  public fetch(url, context, data, category): any {
    this.error = null;

    return this.shortlistSource
      .fetch(url, context, data, category)
      .then(resp => runInAction('successfully updated shortlist', () => resp))
      .catch(err =>
        runInAction('error during shortlist fetch', () => {
          if (this.logger) {
            this.logger.logEvent(STORE_EVENTS.FETCH_ERROR, getErrorString(err));
          }

          // don't assign the error to this.error, as errors in this catch are technical and NOT user friendly
          this.error = true;

          // recover and pass object with error details
          return {
            error: err
          };
        })
      );
  }
}
